<template>
    <div class="stats">
        <div class="cut"/>
        <div class="overlay">
        </div>
        <div class="content">
    		<div class="counter">
                <div class="span-wrapper"><span class="icon-user"/></div>
                <p>Full Automatic VAT Refund</p>
                <p class="small">More than 50bn EUR foreign VAT are left unclaimed on travels every year. WIZY facilitates foreign tax refund for you without you having to do anything about it. Simply use the thrilling WIZY Travel Kit for payments during your travels and get VAT refunded, immediately & with no effort.</p>
            </div>
            <div class="counter">
                <chart class="chart" :chartdata="dataChart" :options="options"/>
            </div>
            <div class="counter">
                <img src="../assets/registration.png"/>
            </div>
        </div>
        <div class="cut-bottom"/>
    </div>
</template>


<script>
import Chart from '../components/Chart.vue'

export default {
  name: "Stats",
  props: [],
  data(){
      return{
          subscriber: Math.round(((new Date().getTime()) / 1000 / 60 / 60 / 24) - 17800),
          dataChart: {
            labels: ['Switzerland', 'Australia', 'South Korea', 'Canada', 'USA', 'NZ', 'Mexico', 'Japan', 'China','World Average','Germany','France','UK','Spain','Russia','Brazil'],
            datasets: [{
                label: 'GST around the world %',
                data: [8,10,10,10,11.7,15,16,16,17,17.5,19,20,20,21,24,25],
                backgroundColor: [
                    
                ],
                borderColor: [
                ],
                borderWidth: 1
            }]
        },
        options: {
            responsive: true,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        }
      }
  },
  components: {
      Chart
  }
};
</script>

<style lang="scss" scoped>
.stats{
    margin-top: 6%;
    margin-bottom: 6%;
    position: relative;
    height: 1000px;
    @media(min-width: 780px){
        height: 900px;
    }
    @media(min-width: 2000px){
        height: 1100px;
    }
    background-image: url('../assets/analytics.jpg');
    background-size: cover;
    background-position: bottom;
    overflow: hidden;
    .overlay{
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 1;
      background: rgb(54,209,220);
      background: linear-gradient(122deg, rgba(54,209,220,0.95) 20%, rgba(91,134,229,0.95) 95%);
    }
    .content{
        position: absolute;
        z-index: 2;
        top: 10%;
        @media(min-width: 780px){
            top: 10%;
        }
        width: 100%;
        text-align: center;
        .counter{
            display: block;
            @media(min-width: 780px){
                display: inline-block;
                width: 25%;
            }
            vertical-align: middle;
            font-size: 3rem;
            padding: 2.5% 2.5% 2.5% 2.5%;
            color: white;
            .span-wrapper{
                margin: 5%;
                span{
                    font-size: 5rem;
                }
            }
            p{
                font-size: 3rem;
                &.small{
                    font-size: 1rem;
                    margin-top: 2%;
                    line-height: 1.5rem;
                    text-align: justify;
                }
            }
            .chart{
                padding: 0;
                margin: 0;
            }
            img{
                display: none;
                @media(min-width: 780px){
                    display: inline-block;
                    max-width: 300px;
                }
            }
        }
    }
    .cut{
        background-color: white;
        position: absolute;
        z-index: 2;
        width: 150%;
        height: 100px;
        transform: rotate(-3deg) translateX(-20%);
        top: -8%;
        @media(min-width: 2000px){
            height: 200px;
            top: -12%;
        }
    }
    .cut-bottom{
        background-color: white;
        position: absolute;
        z-index: 2;
        width: 150%;
        height: 100px;
        transform: rotate(-3deg) translateX(-20%);
        bottom: -4%;
        @media(min-width: 2000px){
            height: 200px;
            bottom: -5%;
        }
    }
}
</style>
